export default {
  // Alerts
  alerts: {
    // Info Alert
    info_alert: {
      title: "Нема достапни податоци",
      description: "IrisFE не можеше да ги преземе бараните информации.",
    },
  },
};
